import { Lead } from 'types/entities/Lead'
import { LeadCategory } from 'types/enums/LeadCategory'
import { LeadStatus } from 'types/enums/LeadStatus'

export const isLinkedOpportunityLead = (lead: Lead | null | undefined): lead is Lead =>
    !!lead && lead.category === LeadCategory.Opportunity

export const isRejectedLinkedOpportunity = (lead: Lead | null | undefined): boolean =>
    isLinkedOpportunityLead(lead) &&
    (lead.status === LeadStatus.Rejection || lead.status === LeadStatus.Disqualified)

export const getLinkedOpportunityRejectionStatus = (lead: Lead): LeadStatus =>
    lead.status === LeadStatus.Disqualified ? LeadStatus.Disqualified : LeadStatus.Rejection
